(function () {
  // Card-level behavior (variant picker, buy/notify, multi-image swipe) is NOT handled here —
  // every card this track renders is snippets/product-card.liquid, the exact same shared
  // component the catalog grid uses, and assets/product-card.js already wires up every
  // [data-card-product] on the page (including these) on its own at parse time. This file's only
  // job is the track itself: centering a short row, and the horizontal "cards nearer the track's
  // own center scale up a touch" coverflow effect — neither has a catalog-grid equivalent, so
  // neither lives in the shared file.
  var tracks = document.querySelectorAll('[data-product-carousel]');

  // Desktop (matches the 1000px breakpoint sections/product-carousel.liquid already uses for
  // card sizing) gets a hover-driven scale instead of this scroll-position-driven one — see
  // that file's own :hover rule. Desktop shoppers scan with the cursor across a row that's
  // rarely even scrollable there (3+ cards fit without scrolling), where mobile shoppers swipe
  // through one card at a time, making scroll position the only signal of "what's in focus".
  // Checked once at load, not on resize: matches how the flex-basis breakpoint itself behaves
  // (a CSS media query, not something that re-evaluates a running JS effect mid-session).
  var isDesktop = window.matchMedia('(min-width: 1000px)').matches;

  tracks.forEach(function (track) {
    // Swiping on to the next card folds any card whose size picker is open — the picker belongs to
    // the card it was opened on, and leaving it expanded while the row moves on reads as a stuck,
    // half-finished state. collapseCard also resets the card back to its default variant.
    var lastScrollLeft = track.scrollLeft;
    track.addEventListener(
      'scroll',
      function () {
        var moved = Math.abs(track.scrollLeft - lastScrollLeft);
        lastScrollLeft = track.scrollLeft;
        if (moved < 4) return;
        var collapse = window.CowalkiesCatalog && window.CowalkiesCatalog.collapseCard;
        if (typeof collapse !== 'function') return;
        track.querySelectorAll('[data-card-product].is-expanded').forEach(collapse);
      },
      { passive: true }
    );

    if (typeof initializeTrackCentering === 'function') {
      initializeTrackCentering(track);
    }

    if (typeof initializeScrollFocus === 'function' && !isDesktop) {
      var cards = Array.from(track.querySelectorAll('[data-card-product]'));
      var focusDelay = parseInt(track.dataset.cardFocusDelay, 10) / 100 || 0;
      initializeScrollFocus(cards, {
        axis: 'x',
        minScale: 0.96,
        maxScale: 1,
        delay: focusDelay,
        scrollContainer: track,
      });
    }
  });
})();
